import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import EventApi from '../../../../Api/EventApi';
import { getResponseError } from '../../../../Api/Utils/apiUtils';
import AddGuest from '../../../../Components/Accounts/AddGuest/AddGuest';
import AllGuests from '../../../../Components/Accounts/AllGuests/AllGuests';
import GuestInvitedStatus from '../../../../Components/Accounts/GuestInvitedStatus/GuestInvitedStatus';
import '../../../../Components/Accounts/GuestInvitedStatus/GuestList.css'
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import Section from '../../../../Components/Section/Section';

const GuestListComponent = () => {
    const { eventid } = useParams()
    const [errorMessage, seterrorMessage] = useState(null);
    const [guests, setguests] = useState([]);
    const [isAddingGuest, setisAddingGuest] = useState(false);

    useEffect(() => {
        const loadGuestList = async () => {
            const response = await EventApi.getGuestList(parseInt(eventid))
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                seterrorMessage(responseApiError)
            }else{
                const guestInfo = response.objectVal
                setguests(guestInfo)
            }
        }
        loadGuestList()
    }, [eventid])

    const inviteAllGuest = async (event) => {
        const response = await EventApi.inviteAllGuest(event)
        const responseApiError = getResponseError(response)
        if (responseApiError) {
            seterrorMessage(responseApiError)
        }else{
            window.location.reload()
        }
    }

    return (
        <>
        {isAddingGuest ?
        <AddGuest setToBack={setisAddingGuest} ID={eventid} />
        :
        <Section>
            
            <Container>

                <ErrorAlert>{errorMessage}</ErrorAlert>
                
                <div className="guest-list-container">
                    <GuestInvitedStatus guestList={guests} eventId={eventid} inviteGuests={inviteAllGuest} />
                    <AllGuests guestList={guests} />
                    <div className="add-guest-button" onClick={() => setisAddingGuest(true)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                </div>
            </Container>
        </Section>}
        </>
    );
};

export default GuestListComponent;
